export default __webpack_public_path__ + "b023f3baa9826808591856565c480836.png";